// react
import React, { Fragment, useContext, useState } from "react";

//axios
import axios from "axios";

// react-router-dom
import { useNavigate } from "react-router-dom";

// mui
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

// context
import { DeviceContext } from "../../Context/deviceContext/deviceContext";
import { SnackbarContext } from "../../Context/snackbarContext/snackbarContext";

// components
import DeviceCard from "../../components/Cards/activationCards/activationCardComponent";
import Snackbar from "../../components/snackbar/snackbarComponent";
import ErrorMessage from "../../components/error/errorComponent";

// images
import ConnectedDevice from "../../assets/connected-device.svg";
import UnconnectedDevice from "../../assets/unconnected-device.svg";

// styles
import useStyles from "./activationStyles";
import { Box } from "@mui/system";

// Activation-Component
const Activation = (props) => {
  // .env variables
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bodyUrl = process.env.REACT_APP_ACTIVATION_MID_URL;
  const iotHubDomain = process.env.REACT_APP_IoT_HUB_DOMAIN;

  const classes = useStyles();
  const navigate = useNavigate();

  const { deviceData, setDeviceData } = useContext(DeviceContext);
  const { setSnackbarData } = useContext(SnackbarContext);

  const [activationCode, setActivationCode] = useState("");
  const [edgeEUI, setEdgeEUI] = useState("");
  const [searchResult, setSearchResult] = useState(true);
  const [deviceState, setDeviceState] = useState(false);
  const [isHealthLoading, setisHealthLoading] = useState(true);

  // device search functionality.
  const handleSearchDevice = () => {
    if (edgeEUI !== "") {
      axios
        .get(`${baseUrl}/${bodyUrl}${edgeEUI}`)
        .then((resp) => {
          if (resp.status == 200) {
            setDeviceData(resp.data);
            setSearchResult(true);
          } else {
            setSearchResult(false);
          }
          setisHealthLoading(false);
        })
        .catch((err) => {
          setSearchResult(false);
        });

      setDeviceState(false);
    }
  };

  // handling the activation part.
  const handleSubmit = (e) => {

    if (activationCode == "") {
      setSnackbarData({
        message: "Please enter the activation code",
        severity: "warning",
        open: true,
      });
    } else if (activationCode == deviceData.fw_activation_code) {
      const data = {
        task: "activateedge",
        data: {
          dev_eui: `${deviceData.dev_eui}`,
          activation_code: `${deviceData.fw_activation_code}`,
          domain: `${iotHubDomain}`,
        },
      };

      axios
        .post(
          `${baseUrl}/fwdeviceActivation/postActivation`,
          JSON.stringify(data)
        )
        .then(
          (response) => {
            if (response.status == 200) {
              setSnackbarData({
                message: "Device activation submitted.",
                severity: "success",
                open: true,
              });
              setDeviceState(true);

              // remove the activation code from the text field.
              setActivationCode("");
            } else {
              setSnackbarData({
                message: "Invalid activation code.",
                severity: "error",
                open: true,
              });
            }
          },
          (error) => {
            setSnackbarData({
              message: "Server is not responding, please try after some time.",
              severity: "error",
              open: true,
            });
          }
        );
    } else {
      setSnackbarData({
        message: "Invalid activation code.",
        severity: "error",
        open: true,
      });
    }
  };

  const handleKeyPress = (e) => {
    var key = e.key;
    if(e.key === 'Enter')
    {
      handleSubmit();
    }
 }

  return (
    <Fragment>
      {/* banner image */}
      <Box className={classes.image} sx = {{marginTop : {xs : '4rem', md : '2.5rem'}}} >
        <img
          src={deviceState ? ConnectedDevice : UnconnectedDevice}
          style={{ width: 300,  }}
          alt="website logo"
        />
      </Box>

      {/* Search Box */}
      <div className={classes.searchBox}>
        <TextField
          style={{ width: 300 }}
          className={classes.textField}
          name="edgeEUI"
          value={edgeEUI}
          id="outlined-basic"
          size="small"
          label="Enter Device EUI"
          variant="outlined"
          onChange={(e) => {
            setEdgeEUI(e.target.value);
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={handleSearchDevice}>
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </div>

      {!searchResult ? (
        <div>
          <ErrorMessage message="Device Not Found" />
        </div>
      ) : (
        <>
          {/* device card */}
          <div className={classes.deviceCard}>
            <DeviceCard
              deviceState={deviceState}
              isHealth={setisHealthLoading}
            />
          </div>

          {/* device activation code form */}
          {!deviceData.isActive && !deviceState ? (
            <>
              <div className={classes.activationCode}>
                <TextField
                  className={classes.textField}
                  name="activationCode"
                  value={activationCode}
                  id="outlined-basic"
                  size="small"
                  label="Enter Activation Code"
                  variant="outlined"
                  onChange={(e) => {
                    setActivationCode(e.target.value);
                  }}
                  InputProps={classes.textField}
                  onKeyPress = {(e) => handleKeyPress(e)}

                />
              </div>

              <div className={classes.button}>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={handleSubmit}
                >
                  Activate
                </button>
              </div>

              <div className={classes.footerText}>
                <p style={{ fontWeight: "bold" }}>
                  You agree that once device activated, it cannot be reverted
                  back to inactive state.
                </p>
              </div>
            </>
          ) : (
            <>
              <div className={classes.footerText}>
                <p style={{ fontWeight: "bold", fontSize: '13px' }}>
                  Device activation submitted.
                </p>
              </div>

              <div className={classes.button}>
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => {
                    setDeviceState(false);
                    navigate("/");
                  }}
                >
                  Back
                </button>
              </div>
            </>
          )}
        </>
      )}

      {/* snackbar */}
      <Snackbar />
    </Fragment>
  );
};

export default Activation;
